import PreviewContext, {
  PreviewContextProvider as PreviewProvider,
} from './PreviewContext';
import container from './container';

const PreviewContextProvider = container(PreviewProvider);

export { PreviewContext as default, PreviewContextProvider };
